export default "__VITE_ASSET__wBZ4W2uO__"